import { render, staticRenderFns } from "./TransactionItems.vue?vue&type=template&id=4df72ce6&"
import script from "./TransactionItems.vue?vue&type=script&lang=js&"
export * from "./TransactionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports